<template lang="pug">
b-modal#getInboxList(
  ref="getInboxList"
  :title="$t('ui.combine.get_inbox_list')"
  centered
  no-fade
  no-close-on-backdrop
  size="lg"
  :busy="loading"
  ok-only
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    div
      b-form-group(:label="$t('ui.inbox')").mb-3
        .row
          .col
            .clusterize-scroll.table-responsive
              table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                thead.thead-light
                  tr
                    th.text-center(width="3%")
                      span #
                    th(width="5%")
                      span {{ $t('ui.id') }}
                    th(width="8%")
                      span {{ $t('ui.member_id') }}
                    th(width="10%")
                      span {{ $t('ui.amount') }}
                    th(width="10%")
                      span {{ $t('ui.campaign') }}
                    th
                      span {{ $t('ui.remark') }}
                    th.text-center(width="8%")
                      span {{ $t('ui.is_claimed') }}
                    th.text-right(width="12%")
                      span {{ $t('ui.claim_date') }}
                    th.text-right(width="12%")
                      span {{ $t('ui.created_date') }}
                    th.text-right(width="12%")
                      span {{ $t('ui.expiry_date') }}
                tbody
                  tr(v-if="inboxList.length == 0")
                      td(colspan="10").text-center
                        span {{ $t('message.no_data_available') }}
                  tr(v-for="(item, index) in inboxList")
                    td.text-center
                      span(:title="index + 1") {{ index + 1 }}
                    td
                      span(:title="item.id") {{ item.id }}
                    td
                      span(:title="item.member_id") {{ item.member_id }}
                    td
                      span(:title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
                    td
                      span(:title="item.campaign") {{ item.campaign }}
                    td
                      span(:title="item.remark") {{ item.remark }}
                    td.text-center
                      span
                        i(:class="{'fas fa-check text-info': item.is_claimed, 'fas fa-times text-warning': !item.is_claimed  }")
                    td.text-right
                      span(v-if="item.claim_date" :title="$moment(item.claim_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.claim_date).format('YYYY-MM-DD, HH:mm:ss') }}
                    td.text-right
                      span(v-if="item.created_date" :title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
                    td.text-right
                      span(v-if="item.expiry_date" :title="$moment(item.expiry_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.expiry_date).format('YYYY-MM-DD, HH:mm:ss') }}
    .row
      .col-12
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fas fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import BankGroupLookup from "@/library/BankGroupLookup";
import BankAccType from "@/library/BankAccType";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);
const greaterThanZero = (value) => value > 0;

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    BankAccType,
    BankGroupLookup
  },
  props: {
    item: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      account_id: '',
      inboxList: [],
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
  },
  methods: {
    getInboxList: function() {
      let url = config.inboxListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        member_id: this.item.account_id
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.inboxList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.account_id = this.item.account_id;
      this.getInboxList();
    }
  }
};
</script>
